

// Enables links to files to be dragged out from browser to explorer

angular.module('admin')
.directive('dragout', function() {
	return {
        restrict: 'A'
        , scope: { 'dragout': '@' }  // interpolated
        , link: function(scope, element, attrs){
            
        	var rawelem = element.get(0);
			if (!rawelem.addEventListener) {
				console.debug('Dragout: no addEventListener');
				return;
			}
			rawelem.addEventListener('dragstart', function(evt){
				//console.debug('dragstart', scope.dragout, evt);
				if (scope.dragout && evt.dataTransfer) {
					//console.debug('DownloadURL', scope.dragout);
					evt.dataTransfer.setData("DownloadURL", scope.dragout);
				} else if (scope.dragout) {
					console.debug('Dragout: evt.dataTransfer not supported');
				}
			}, false);

        }//link

    };//return
})